import * as React from "react";
import { connect } from "react-redux";

import { closeTagModal, tagProcesses } from "../../actions/ProcessListActions";
import { DispatchType } from "../../../shared/utilities";
import { State } from "../../model/State";
import { Option } from '../../../shared/model/Option';
import BatchTagModal from "shared/components/BatchTagModal";

const BatchTagDialog: React.FC<BatchTagDialogProps> = (props) => (
    <BatchTagModal {...props} />
)

interface BatchTagDialogOwnProps {
    processIds: number[];
}

interface BatchTagDialogStateProps {
    availableTags: Option[];
}

interface BatchTagDialogDispatchProps {
    onAddTags: (tags: string[]) => void;
    onOverwriteTags: (tags: string[]) => void;
    onCancel: () => void;
}

type BatchTagDialogProps = BatchTagDialogOwnProps & BatchTagDialogStateProps & BatchTagDialogDispatchProps;

const mapStateToProps = (state: State, ownProps: BatchTagDialogOwnProps): BatchTagDialogStateProps => {
    return {
        availableTags: state.availableTags.map((t) => ({ value: t, label: t }))
    };
};

const mapDispatchToProps = (dispatch: DispatchType<State>, ownProps: BatchTagDialogOwnProps): BatchTagDialogDispatchProps => {
    return {
        onAddTags: (tags: string[]) => dispatch(tagProcesses(ownProps.processIds, tags, false)),
        onOverwriteTags: (tags: string[]) => dispatch(tagProcesses(ownProps.processIds, tags, true)),
        onCancel: () => dispatch(closeTagModal())
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(BatchTagDialog);
